import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger, Persona } from '@fluentui/react-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from '../../routes/__root';
import LicenseDialog from '../License/LicenseDialog';

export function IdentityMenu() {
  const { instance } = useMsal();
  const { t } = useTranslation();
  const [licenseDialogOpen, setLicenseDialogOpen] = useState(false);
  const context = Route.useRouteContext();

  const handleLogout = () => {
    instance.logoutRedirect({
      account: instance.getActiveAccount(),
      postLogoutRedirectUri: '/',
    });
  };

  const handleLogin = () => {
    instance.loginRedirect();
  };

  return (
    <div>
      <AuthenticatedTemplate>
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button appearance="subtle">
              <Persona
                name={instance.getActiveAccount()?.name}
                secondaryText={instance.getActiveAccount()?.username}
                textPosition="before"
              />
            </Button>
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              {context.licenseChecker.getHasUserValidLicense() && (
                <MenuItem onClick={() => setLicenseDialogOpen(true)}>{t('license.dialog.title')}</MenuItem>
              )}
              <MenuItem onClick={handleLogout}>{t('misc.logout')}</MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <LicenseDialog open={licenseDialogOpen} onClose={() => setLicenseDialogOpen(false)} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Persona onClick={handleLogin} />
      </UnauthenticatedTemplate>
    </div>
  );
}
